import { notification } from 'antd';
import React from 'react';
import { initUhi } from '../../api/login';
import { captureError } from '../../pages/captureError';
import { track } from '../../tracking';

const LoginWithUHI: React.FC = () => {
    const loginWithUHIHandler = () => {
        initUhi()
            .then((responseData) => window.open(responseData.data.authUrl, '_self'))
            .catch((error) => {
                captureError(error);
                notification.error({
                    message: error.message,
                    duration: 5,
                });
            });
        track('INIT_UHI_LOGIN');
    };

    return (
        <a
            onClick={loginWithUHIHandler}
            className="cursor-pointer text-actionPrimary font-300 text-14 mb-30"
        >
            Login with PHPR
        </a>
    );
};

export default LoginWithUHI;
